"use client";

import {
  deriveBreakAvailability,
  toTherapistCardData,
} from "~/components/therapist/therapist-card/from-search-result";
import { TherapistCard } from "~/components/therapist/therapist-card/therapist-card";
import type { DiscoverySurface } from "~/components/therapist/therapist-card/types";
import { useDailyAvailability } from "~/components/therapist/daily-availability-context";
import type { TherapistSearchResult } from "~/server/services/therapist-search";

interface TherapistResultCardProps {
  therapist: TherapistSearchResult;
  isCouplesTherapy: boolean;
  discoverySurface?: DiscoverySurface;
  specialtySlug?: string;
  preserveCouplesQuery: boolean;
  resultRank: number;
}

/**
 * `useDailyAvailability` needs a client component. This is the seam that
 * lets `ListTherapistsResults` stay a server component while each card still
 * reads live per-day availability from `DailyAvailabilityProvider`.
 */
export default function TherapistResultCard({
  therapist,
  isCouplesTherapy,
  discoverySurface,
  specialtySlug,
  preserveCouplesQuery,
  resultRank,
}: TherapistResultCardProps) {
  const batchAvailability = useDailyAvailability(therapist.slug);
  const breakAvailability = deriveBreakAvailability(therapist);

  return (
    <TherapistCard
      therapist={toTherapistCardData(therapist)}
      isCouplesTherapy={isCouplesTherapy}
      availability={breakAvailability ?? batchAvailability}
      discoverySurface={discoverySurface}
      specialtySlug={specialtySlug}
      preserveCouplesQuery={preserveCouplesQuery}
      resultRank={resultRank}
    />
  );
}
